import React from 'react';
import { PreviewLayoutTemplate } from 'themes/layouts';

function PreviewLayout(props) {
    return <PreviewLayoutTemplate {...props} />;
}

export default PreviewLayout;
